import { ShipmentStatusWithSegmentPoint } from './shipment-status-with-segment-point';

export class ShipmentTrackingTimeStatusSegment {
  shipmentUuid!: string;

  pickupWindowStart!: string;
  pickupWindowEnd!: string;

  pickupStartPercentage!: number;
  pickupEndPercentage!: number;
  pickupBeforeInterval = false;
  pickupAfterInterval = false;

  deliveryWindowStart!: string;
  deliveryWindowEnd!: string;

  deliveryStartPercentage!: number;
  deliveryEndPercentage!: number;
  deliveryAfterInterval = false;
  deliveryBeforeInterval = false;

  achievedWindowStart: string | null | undefined = null;
  achievedWindowEnd: string | null | undefined = null;

  achievedStartPercentage: number | null | undefined = null;
  achievedEndPercentage: number | null | undefined = null;
  achievedMissedEstimated = false;
  achievedBeforeInterval = false;
  achievedMissedDelivery = false;
  achievedMissedPickup = false;

  statuses: ShipmentStatusWithSegmentPoint[] = [];
}
